// extracted by mini-css-extract-plugin
module.exports = {"notFound":"LWccV","notFoundGraphic":"Evj_N","swing":"_1hE-D","errorImage":"_3vcm9","oops":"Nqe1-","animated":"_2DvCr"};